// extracted by mini-css-extract-plugin
export default {"Main":"Badge_Main__zVPjT","active":"Badge_active__SqhoQ"};